<template>
  <div class="idsk-header-web__nav--divider" />
</template>